export default __webpack_public_path__ + "static/media/FreePlayWithSparkles.b15df6b4.png";